'use strict';

const React = require('react');
const LOADER_DELAY = 250; // in ms

class PageLoader extends React.Component {
	constructor(props) {
		super(props);
		this._timoutId = -1;
		this.state = { showLoader: false };
	}

	componentWillUnmount() {
		this.stopTimeout();
	}
	
	componentDidMount() {
		this.startTimeout(LOADER_DELAY);
	}
	
	startTimeout(period) {
		this._timoutId = setTimeout(function () {
			this._timoutId = -1;
			this.timeoutDone();
		}.bind(this), period);
	}
	
	stopTimeout() {
		clearTimeout(this._timoutId);
		this._timoutId = -1;
	}
	
	timeoutDone() {
		this.setState({
			showLoader: true
		});
	}
	
	render() {
		if (!this.state.showLoader) {
			return (
				<article className="svtse_page-loader"></article>
			);
		}
		return (
			<article className="svtse_page-loader">
				<img src="/static/svtse-render/images/ajax-loader.gif" alt="Laddar..." className="svtse_page-loader__img" />
			</article>
		);
	}

}

module.exports = PageLoader;



/** WEBPACK FOOTER **
 ** ./app/components/PageLoader.js
 **/